// Light/dark toggle. The blocking script in the layout <head> already set
// data-theme on <html> before paint (avoiding a flash); this just wires up
// the button to flip it and persist the choice. Bound via delegation on
// document so it survives Turbo swapping the nav partial back in, without
// needing the same double-mount guard react_mount.jsx uses for React.
function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("theme", theme);

  document.querySelectorAll("[data-theme-toggle]").forEach((button) => {
    button.setAttribute("aria-label", theme === "dark" ? "Switch to light theme" : "Switch to dark theme");
    button.querySelector("[data-theme-icon-dark]")?.classList.toggle("hidden", theme !== "dark");
    button.querySelector("[data-theme-icon-light]")?.classList.toggle("hidden", theme === "dark");
  });
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-theme-toggle]");
  if (!button) return;

  const current = document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
  applyTheme(current === "dark" ? "light" : "dark");
});

document.addEventListener("turbo:load", () => {
  applyTheme(document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark");
});
